import {ReviewEntry} from "src/app/model/ReviewEntry";
import {generateReviewUrl} from "src/app/util/ReviewUrlUtil";

export const REVIEW_EXPORT_TABLE_HEADER = [{
    label: "Transporter ID",
    property: "referenceId",
}, {
    label: "Case ID",
    formatter: function (rowIndex: number, rowData: ReviewEntry) {
        var linkElement = document.createElement("kat-link");
        linkElement.setAttribute("href", generateReviewUrl(rowData.reviewId));
        linkElement.setAttribute("label", rowData.reviewId);
        linkElement.setAttribute("variant", "link");
        linkElement.setAttribute("target", "_blank");

        return {
            element: linkElement,
        };
    },
}, {
    label: "Case Type",
    property: "caseType",
}, {
    label: "Sub Case Type",
    property: "caseSubType",
}, {
    label: "Review Status",
    property: "reviewStatus",
}, {
    label: "Review Result",
    property: "reviewResult",
}, {
    label: "Creation Date",
    property: "creationDate",
}, {
    label: "Primary Case Completion Date",
    formatter: function (rowIndex: number, rowData: ReviewEntry) {
        const textElement = document.createElement("span");
        textElement.textContent = rowData.primaryCaseCompletionDate || "-";
        return {
            element: textElement,
        };
    },
}, {
    label: "Secondary Case Completion Date",
    formatter: function (rowIndex: number, rowData: ReviewEntry) {
        const textElement = document.createElement("span");
        textElement.textContent = rowData.secondaryCaseCompletionDate || "-";
        return {
            element: textElement,
        };
    },
}
];

export const REVIEW_EXPORT_FILE_HEADER = "Transporter Type,Country,Transporter ID,Long Version Provider ID," +
    "Case ID,Case Type,Sub Case Type,Case Creation Time,Primary Case Completion Date,Secondary Case Completion Date,Review Status,Review Result,Case URL";